module.exports = __webpack_public_path__ + "media/src/images/image_login-9542f18feff7805bc43c6c0aaa87b31e.svg";